import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 24px;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 24px;
`;

const Text = styled.p`
  line-height: 1.6;
  color: #666;
  margin-bottom: 8px;
`;

export const LegalNoticePage: React.FC = () => {
  return (
    <Container>
      <Title>Legal Notice / Impressum</Title>
      
      <Section>
        <Text><strong>Company Name:</strong> Storify-Now SRL</Text>
        <Text><strong>Address:</strong> [Your Full Address]</Text>
        <Text><strong>Registration Number:</strong> [Registration Number]</Text>
        <Text><strong>VAT ID:</strong> [VAT Number]</Text>
        <Text><strong>Email:</strong> legal@storify-now.com</Text>
      </Section>

      <Section>
        <Text><strong>Represented by:</strong> [Managing Director Name]</Text>
      </Section>

      <Section>
        <Text><strong>Responsible for content according to § 55 Abs. 2 RStV:</strong></Text>
        <Text>[Name and Address]</Text>
      </Section>
    </Container>
  );
};